import { Button } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { t } from 'ttag';
import CustomButton from '@/shared/ui/components/customButton';
import { closeGreyIcon, closePrimaryDarkIcon } from './assets';
import styles from './style.module.scss';
import { useModalHeader } from './useModalHeader';

interface IBaseProps {
  /** Class name of the component  */
  className?: string;
}

interface IProps extends IBaseProps {
  /** Title */
  title?: string;
  /** Show button or not */
  isShowBtn?: boolean;
  /** Show drawer button or not */
  isShowDrawerBtn?: boolean;
  /** Button class name */
  buttonClassName?: string;
  /** Button title */
  buttonTitle?: string;
  /** Event click button */
  onClick?: (e: any) => void;
}

/**
 * Title bar for modals and drawers carrying a close or labeled action button. Renders the title plus an Ant Design text button when isShowBtn, and for the drawer variant a secondary CustomButton, sizing both the icon and the button from the isMobile flag reported by useModalHeader.
 *
 * @param props - Header title, class names, button title and drawer-button flags, and the click handler.
 * @returns The rendered modal header element.
 */
const ModalHeader = (props: IProps): React.JSX.Element => {
  const { isShowBtn = true } = props;
  const { isMobile } = useModalHeader();

  return (
    <div className={classNames(styles.modalHeader, props.className)}>
      <div className={styles.modalHeaderTitle}>{props.title}</div>
      {isShowBtn && (
        <Button
          onClick={props.onClick}
          aria-label={!props.buttonTitle ? t`Close` : undefined}
          className={classNames(styles.modalHeaderButton, props.buttonClassName)}
          icon={
            !props.buttonTitle ? (
              <img width={24} height={24} src={closeGreyIcon} alt="" />
            ) : undefined
          }
          size="large"
          type="text"
        >
          {props.buttonTitle}
        </Button>
      )}
      {props.isShowDrawerBtn && (
        <CustomButton
          id="drawer-btn"
          onClick={props.onClick}
          ariaLabel={!props.buttonTitle ? t`Close` : undefined}
          className={classNames(styles.modalHeaderButton, props.buttonClassName)}
          icon={
            !props.buttonTitle ? (
              <img
                width={isMobile ? 20 : 24}
                height={isMobile ? 20 : 24}
                src={closePrimaryDarkIcon}
                alt=""
              />
            ) : undefined
          }
          size={isMobile ? 'small' : 'middle'}
          type="secondary"
        >
          {props.buttonTitle}
        </CustomButton>
      )}
    </div>
  );
};

export default ModalHeader;
